import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/language-context";
import { Compass } from "lucide-react";
import { Link } from "wouter";

export default function NotFound() {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-accent/5 flex items-center justify-center px-6">
      <div className="max-w-lg w-full text-center">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-primary flex items-center justify-center">
          <Compass className="w-10 h-10 text-primary-foreground" />
        </div>
        <h1 className="font-serif text-4xl md:text-5xl font-medium mb-4">
          {t.notFound.title}
        </h1>
        <p className="text-lg text-muted-foreground max-w-md mx-auto mb-8">
          {t.notFound.subtitle}
        </p>
        <Button asChild size="lg" data-testid="button-back-home">
          <Link href="/">{t.notFound.backHome}</Link>
        </Button>
      </div>
    </div>
  );
}
